<div
  class="organization-menu flex-col h-100 w-100"
  [class.expanded]="selectorOpen()"
>
  @if (hasMultipleOrganizations()) {
    <div class="organization-rail flex-col w-100">
      @if (showOrganizationSearch()) {
        @if (selectorOpen()) {
          <label class="organization-search">
            <span class="ui-icon-search" aria-hidden="true"></span>
            <input
              type="search"
              autocomplete="off"
              autofocus
              [placeholder]="'SIDEBAR.SEARCH_ORGANIZATION' | translate"
              [attr.aria-label]="'SIDEBAR.SEARCH_ORGANIZATION' | translate"
              [value]="searchQuery()"
              (input)="updateSearch($event)"
            />
          </label>
        } @else {
          <button
            type="button"
            class="organization-search-trigger flex-row center-center"
            [attr.aria-label]="'SIDEBAR.SEARCH_ORGANIZATION' | translate"
            [matTooltip]="'SIDEBAR.SEARCH_ORGANIZATION' | translate"
            matTooltipClass="sidebar-tooltip"
            matTooltipPosition="right"
            (click)="openSelector()"
          >
            <span class="ui-icon-search" aria-hidden="true"></span>
          </button>
        }
      }
      <div
        #organizationList
        class="organization-shortcuts flex-col start-center w-100"
        [class.expanded]="selectorOpen()"
        [attr.role]="selectorOpen() ? 'listbox' : null"
        [attr.aria-label]="'CHAT_AUTH.ORGANIZATION' | translate"
      >
        @for (item of shortcutOrganizations(); track item.id) {
          <button
            type="button"
            class="organization-shortcut flex-row center-center"
            [class.compact-hidden]="
              !selectorOpen() && $index >= visibleCompactOrganizations()
            "
            [class.search-hidden]="selectorOpen() && !matchesSearch(item.name)"
            [attr.aria-label]="
              organizationAriaLabel(item.name, item.synapseSpaceId)
            "
            [attr.aria-selected]="
              selectorOpen() ? item.id === organization()?._id : null
            "
            [matTooltip]="item.name"
            [matTooltipDisabled]="selectorOpen()"
            matTooltipClass="sidebar-tooltip"
            matTooltipPosition="right"
            [disabled]="switchInProgress()"
            (click)="switchOrganization(item.id)"
          >
            <ui-avatar
              class="organization-avatar"
              [name]="item.name"
              [color]="item.color"
            ></ui-avatar>
            @if (organizationUnreadCount(item.synapseSpaceId) > 0) {
              <span class="organization-unread-badge" aria-hidden="true">{{
                unreadBadgeLabel(item.synapseSpaceId)
              }}</span>
            }
            <span class="organization-name" [class.visible]="selectorOpen()">{{
              item.name
            }}</span>
          </button>
        }
      </div>

      @if (!selectorOpen() && hasHiddenOrganizations()) {
        <button
          type="button"
          class="organization-expand flex-row center-center"
          [attr.aria-label]="hiddenOrganizationsAriaLabel()"
          [matTooltip]="'SIDEBAR.SHOW_ORGANIZATIONS' | translate"
          matTooltipClass="sidebar-tooltip"
          matTooltipPosition="right"
          (click)="openSelector()"
        >
          <span class="ui-icon-arrow-down" aria-hidden="true"></span>
          @if (hiddenOrganizationsUnreadTotal() > 0) {
            <span class="organization-unread-badge" aria-hidden="true">{{
              hiddenOrganizationsUnreadTotal() > 99
                ? '99+'
                : hiddenOrganizationsUnreadTotal()
            }}</span>
          }
        </button>
      }
    </div>
  }

  @if (!selectorOpen()) {
    <div class="sidebar-bottom flex-col w-100">
      <app-user-menu></app-user-menu>
      <button
        type="button"
        class="organization-trigger flex-row center-center"
        [attr.aria-label]="
          organizationAriaLabel(
            activeOrganizationName(),
            organization()?.settings?.synapseSpaceId
          )
        "
        [attr.aria-expanded]="selectorOpen()"
        [matTooltip]="'CHAT_AUTH.ORGANIZATION' | translate"
        [matTooltipDisabled]="selectorOpen() || !hasMultipleOrganizations()"
        matTooltipClass="sidebar-tooltip"
        matTooltipPosition="right"
        [disabled]="!hasMultipleOrganizations()"
        (click)="openSelector()"
      >
        <ui-avatar
          class="organization-avatar"
          [name]="activeOrganizationName()"
          [color]="activeOrganizationColor()"
        ></ui-avatar>
        @if (
          organizationUnreadCount(organization()?.settings?.synapseSpaceId) > 0
        ) {
          <span class="organization-unread-badge" aria-hidden="true">{{
            unreadBadgeLabel(organization()?.settings?.synapseSpaceId)
          }}</span>
        }
      </button>
    </div>
  }
</div>
